var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper",class:{ stickyClass: _vm.sticky },style:({ 'background-color': _vm.back, color: _vm.font })},[_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('hr',{staticClass:"line",style:({ 'border-top': '2px solid ' + _vm.font })})])
}
var staticRenderFns = []

export { render, staticRenderFns }